import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory as history,
  useLocation as location,
} from "react-router-dom";

//Redux
import { Provider } from "react-redux";
import store from "./store";
import { auth } from "./actions/auth";
import {
  mainCategories,
  childCategories,
  subCategories,
  childSubCategories,
} from "./actions/categories";
import PrivateRoute from "./routing/PrivateRoute";

// components
import Header from "./components/header/header.component";
import Footer from "./components/footer/footer.component";

// home page
import Index from "./pages/index";
import Category from "./pages/category";
import ChildCategory from "./pages/childCategory";
import SubCategory from "./pages/subCategory";
import ChildSubCategory from "./pages/childSubCategory";
import AboutUs from "./pages/aboutUs/aboutUs";
import PrivacyPolicy from "./pages/privacyPolicy";
import CookiePolicy from "./pages/privacyPolicy/cookiePolicy";
import Disclaimer from "./pages/privacyPolicy/disclaimer";
import Terms from "./pages/privacyPolicy/terms";
import Register from "./pages/register";
import Login from "./pages/login";
import SingleProduct from "./pages/product/singleProduct";
import ReturnPolicy from "./pages/returnPolicy";
import Dashboard from "./pages/dashboard";
import SellerDashboard from "./pages/sellerDashboard/sellerDashboard";
import CustomerService from "./pages/customerService";
import EditAccount from "./pages/editAccount";
import ChangePassword from "./pages/changePassword";
import Wishlist from "./pages/wishlist";
import MyOrders from "./pages/myOrders/myOrders";
import orderReview from "./pages/myOrders/orderReview";
import RewardPoint from "./pages/rewardPoints";
import Transaction from "./pages/transactions";
import Newsletter from "./pages/newsletter";
import SellerOrders from "./pages/sellerOrders/sellerOrders";
import Search from "./pages/search";
import Cart from "./pages/cart/cart";
import Checkout from "./pages/checkout";
import MembershipPackage from "./pages/membershipPackages";
import StoreInformation from "./pages/storeInformation/storeInformation";
import BulkProductsUpload from "./pages/bulkProductsUpload/bulkProductsUpload";
import AddressBook from "./pages/addressBook";
import AddNewAddressBook from "./pages/addressBook/addNew";
import EditAddressBook from "./pages/addressBook/edit";
import BecomeVendor from "./pages/becomeVendor";
import SellerProduct from "./pages/sellerProducts/sellerProducts";
import BrandDetails from "./pages/brandDetails";
import DailySale from "./pages/dailySale";
import AccountVerification from "./pages/accountVerification";
import ForgetPassword from "./pages/forgetPassword";
import ResetPassword from "./pages/forgetPassword/reset";
import ViewAll from "./pages/viewAll/index";

import { withRouter } from "react-router-dom";
class App extends React.Component {
  constructor({ props }) {
    super(props);
  }

  componentDidMount() {
    store.dispatch(auth());
    store.dispatch(mainCategories());
    store.dispatch(childCategories());
    store.dispatch(subCategories());
    store.dispatch(childSubCategories());
  }

  render() {
    return (
      <Provider store={store}>
        <Router history={history}>
          {console.log(history)}
          <Header />
          <div className="wrapper bg-hover-gray ">
            <Switch>
              <Route path="/" exact>
                <Index />
              </Route>

              <Route history={true} path="/category/:slug" exact>
                <Category />
              </Route>
              <Route path="/sub-category/:slug" exact>
                <ChildCategory />
              </Route>
              <Route path="/about-us" exact>
                <AboutUs />
              </Route>
              <Route path="/brand/:slug" exact>
                <BrandDetails />
              </Route>

              <Route path="/daily-sale" exact>
                <DailySale />
              </Route>

              <Route path="/privacy-policy" exact>
                <PrivacyPolicy />
              </Route>

              <Route path="/recently-view" exact>
                <ViewAll />
              </Route>
              <Route path="/cookie-policy" exact>
                <CookiePolicy />
              </Route>
              <Route path="/disclaimer" exact>
                <Disclaimer />
              </Route>
              <Route path="/term-conditions" exact>
                <Terms />
              </Route>

              <Route path="/products/:slug/:page" exact>
                <SubCategory />
              </Route>
              <Route path="/category/products/:slug" exact>
                <ChildSubCategory />
              </Route>
              <Route path="/product/:slug" history={true} exact>
                <SingleProduct />
              </Route>
              <Route path="/login" exact>
                <Login />
              </Route>
              <Route path="/register" exact>
                <Register />
              </Route>
              <Route path="/return-policy" exact>
                <ReturnPolicy />
              </Route>
              <Route path="/shopping-cart" exact>
                <Cart />
              </Route>
              <PrivateRoute path="/checkout" exact component={Checkout} />
              <PrivateRoute exact path={"/dashboard"} component={Dashboard} />
              <PrivateRoute
                exact
                path={"/seller-dashboard"}
                component={SellerDashboard}
              />
              <PrivateRoute
                path="/edit-account"
                exact
                component={EditAccount}
              />
              <PrivateRoute
                path="/change-password"
                component={ChangePassword}
              />
              <PrivateRoute exact path={"/wishlist"} component={Wishlist} />
              <PrivateRoute exact path={"/my-orders"} component={MyOrders} />
              <PrivateRoute
                exact
                path={"/order-review/:id"}
                component={orderReview}
              />
              <PrivateRoute
                exact
                path={"/reward-points"}
                component={RewardPoint}
              />
              <PrivateRoute
                exact
                path={"/transactions"}
                component={Transaction}
              />
              <PrivateRoute exact path={"/newsletter"} component={Newsletter} />
              <PrivateRoute
                exact
                path={"/seller-orders"}
                component={SellerOrders}
              />
              <PrivateRoute
                exact
                path={"/membership-packages"}
                component={MembershipPackage}
              />
              <PrivateRoute
                exact
                path={"/seller-store-information"}
                component={StoreInformation}
              />
              <PrivateRoute
                exact
                path={"/bulk-products-upload"}
                component={BulkProductsUpload}
              />
              <PrivateRoute
                exact
                path={"/vendor-registeration"}
                component={BecomeVendor}
              />
              <Route
                path="/customer-service"
                exact
                component={CustomerService}
              />

              <PrivateRoute
                path="/address-book"
                exact
                component={AddressBook}
              />

              <PrivateRoute
                path="/add-new-address-book"
                exact
                component={AddNewAddressBook}
              />
              <PrivateRoute
                exact
                path={"/seller-products"}
                component={SellerProduct}
              />
              <Route path="/edit-address-book/:id" exact>
                <EditAddressBook />
              </Route>
              <Route path="/verify" exact>
                <AccountVerification />
              </Route>
              <Route path="/forget-password" exact>
                <ForgetPassword />
              </Route>
              <Route path="/reset/:token" exact>
                <ResetPassword />
              </Route>
              <Route path="/search/:id" exact>
                <Search />
              </Route>
            </Switch>
            <Footer />
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
